<script>
  export let title = 'Heading';
  export let description = '';
  export let direction = 'ltr';
  export let featuredImage = '//via.placeholder.com/564x466';
  export let features = [];
</script>

<style>
  .tipper {
    display: flex;
    margin-bottom: 4vw;
  }

  .tipper .row {
    justify-content: space-between;
    align-items: flex-start;
    max-width: 1400px;
  }

  .tipper.rtl .row {
    flex-direction: row-reverse;
  }

  .tipper .row .col {
    position: relative;
    flex: 1;
    z-index: 0;
  }

  .tipper .row .col:first-child {
    margin-right: 4vw;
  }

  .tipper.rtl .row .col:first-child {
    margin-right: 0;
    margin-left: 4vw;
  }

  .tipper .row .col img.featured-image {
    z-index: 0;
    margin-top: 32px;
    -webkit-box-shadow: 0px 10px 48px -20px var(--dark-alpha-7);
    -moz-box-shadow: 0px 10px 48px -20px var(--dark-alpha-7);
    box-shadow: 0px 10px 48px -20px var(--dark-alpha-7);
    width: 500px;
    height: 413px;
  }

  .tipper .row .col .background {
    width: 500px;
    height: 413px;
    background-color: var(--secondary);
    border-radius: 64px 0 0;
    position: absolute;
    top: 0;
    left: 64px;
    z-index: -1;
  }

  .tipper.rtl .row .col .background {
    border-radius: 0 64px 0 0;
    top: 0;
    left: 0;
    z-index: -1;
  }

  .tipper.rtl .row .col img {
    margin-left: 64px;
  }

  .tipper .row .col .feature-container {
    display: grid;
    grid-template-columns: 72px auto;
    grid-gap: 1vw;
    align-items: flex-start;
  }

  .tipper .row .col .feature-container .icon-container img {
    margin: 0;
    width: 64px;
  }

  .tipper .row .col .feature-container .feature-details > * {
    margin-bottom: 1vw;
    font-size: 20px;
    font-family: 'Open Sans Thin', Arial, Helvetica, sans-serif;
  }

  .tipper .row .col .feature-container .feature-details .feature-items {
    list-style-type: "\2192";
  }

  .tipper .row .col .feature-container .feature-details .feature-items li {
    margin-bottom: 1vw;
    padding-left: 1vw;
  }

  .tipper .row .col .feature-container .feature-details {
    margin: 0 1vw;
  }

  .tipper .row .col .feature-container .feature-details ul {
    padding-left: 2vw;
  }

  /* Small devices (landscape phones, 767px and up) */
  @media (max-width: 767px) {
    .tipper .row {
      flex-direction: column;
    }

    .tipper .row .col.col-relative {
      display: none;
    }
  }

  /* Medium devices (tablets, 768px and up) */
  @media (min-width: 768px) {

  }

  /* Large devices (desktops, 992px and up) */
  @media (min-width: 992px) {

  }

  /* Extra large devices (large desktops, 1200px and up) */
  @media (min-width: 1200px) {
  }

  /* Super large devices (large desktops, 1400px and up) */
  @media (min-width: 1400px) {
    .tipper .row .col img.featured-image {
      width: 564px;
      height: 466px;
    }

    .tipper .row .col .background {
      width: 564px;
      height: 466px;
    }
  }
</style>

<main class={direction && direction === 'rtl' ? 'tipper rtl' : 'tipper'}>
  <div class="row">
    <div class="col">
      <h3 class="subtitle margin-bottom-2vw">{@html title}</h3>
      <p class="lead-paragraph margin-bottom-2vw">{description}</p>
      {#each features as feature}
      <div class="feature-container">
        <div class="icon-container">
          <img src={feature.icon} alt={feature.name}>
        </div>
        <div class="feature-details padding-right-2vw padding-light-2vw">
          <h4 class="feature-name">{feature.name}</h4>
          {#if feature.description}
          <p class="feature-description">{feature.description}</p>
          {/if}
          <ul class="feature-items">
            {#each feature.items as item}
            <li>{item}</li>
            {/each}
          </ul>
        </div>
        
      </div>
      {/each}
    </div>
    <div class="col col-relative">
      <img class="featured-image" src={featuredImage} alt={title}>
      <div class="background"></div>
    </div>
  </div>
</main>